// extracted by mini-css-extract-plugin
export default {"container":"Testimonials_container__n-cHL","slideContainer":"Testimonials_slideContainer__VsaEh","card":"Testimonials_card__L6TeL","cardImage":"Testimonials_cardImage__8IVEB"};